var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32Camera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 46,
    viewBox: "0 0 56 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0062 42.6671H5.99567C3.78877 42.6671 2 40.8784 2 38.6715V14.6611C2 12.4542 3.78877 10.6673 5.99567 10.6673H12.3426C13.387 10.6673 14.3695 10.1742 14.9958 9.33983L19.0065 3.99227C19.6327 3.15788 20.6152 2.66663 21.6577 2.66663H34.3423C35.3866 2.66663 36.3692 3.15788 36.9954 3.99227L41.0061 9.33983C41.6323 10.1742 42.6149 10.6673 43.6593 10.6673H50.0062C52.2131 10.6673 54 12.4542 54 14.6611V38.6715C54 40.8784 52.2131 42.6671 50.0062 42.6671Z",
    stroke: "#0A7E85",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 24.6666C38 30.1897 33.5226 34.6666 27.9991 34.6666C22.4755 34.6666 18 30.1897 18 24.6666C18 19.1436 22.4755 14.6666 27.9991 14.6666C33.5226 14.6666 38 19.1436 38 24.6666Z",
    stroke: "#0A7E85",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Camera);
export default __webpack_public_path__ + "static/media/icon32_camera.a85eed2118c4cf3898d8b481ea740872.svg";
export { ForwardRef as ReactComponent };